import "./ProgressBarComp.css";
import { defineComponent as n, useCssVars as d, openBlock as i, createBlock as u, Transition as c, withCtx as l, createElementVNode as t, normalizeStyle as o } from "vue";
import { _ } from "./_plugin-vue_export-helper.dad06003.js";
const r = n({
  name: "progress-bar-comp",
  props: {
    progress: {
      type: Number,
      default: 0
    },
    blue: {
      type: Boolean,
      default: !1
    },
    borderRadius: {
      type: Number,
      default: 6
    },
    progressWidth: {
      type: String,
      default: "100%"
    },
    progressHeight: {
      type: String,
      default: "10px"
    }
  },
  computed: {
    containerStyle() {
      return {
        "border-radius": `${this.borderRadius}px`
      };
    },
    trackStyles() {
      return {
        width: `${this.progress}%`,
        backgroundColor: this.blue ? "#0068AD" : "#84bd00",
        "border-radius": `${this.borderRadius}px`
      };
    }
  }
}), a = () => {
  d((e) => ({
    "749286e6": e.progressWidth,
    "515c4980": e.progressHeight
  }));
}, p = r.setup;
r.setup = p ? (e, s) => (a(), p(e, s)) : a;
function g(e, s, m, f, y, b) {
  return i(), u(c, {
    name: "progress",
    appear: ""
  }, {
    default: l(() => [
      t("div", {
        class: "progress",
        style: o(e.containerStyle)
      }, [
        t("div", {
          class: "progress-track",
          style: o(e.trackStyles)
        }, null, 4)
      ], 4)
    ]),
    _: 1
  });
}
const $ = /* @__PURE__ */ _(r, [["render", g], ["__scopeId", "data-v-eac2ea4c"]]);
export {
  $ as ProgressBarComp
};
//# sourceMappingURL=ProgressBarComp.js.map
